import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { usePageSEO } from "@/hooks/usePageSEO";

const LAST_UPDATED = "June 2, 2026";

export default function RefundPolicy() {
  const { t } = useLanguage();
  usePageSEO({
    title: "Refund Policy – ISO27001KIT",
    description: "Refund policy for ISO27001KIT products including Pro tools subscription and Document Pack.",
  });
  
  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold mb-4 text-foreground">{t('refund.title')}</h1>
        <div className="h-1 w-24 bg-primary mb-8"></div>
        
        <div className="prose prose-slate dark:prose-invert max-w-none space-y-6 text-foreground">
          <p className="text-sm text-muted-foreground">{t('refund.lastUpdated')} {LAST_UPDATED}</p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">{t('refund.noRefunds.title')}</h2>
            <p>{t('refund.noRefunds.content')}</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">{t('refund.reviewMode.title')}</h2>
            <p>{t('refund.reviewMode.content')}</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">{t('refund.wordPack.title')}</h2>
            <p>{t('refund.wordPack.content1')}</p>
            <p>{t('refund.wordPack.content2')}</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">{t('refund.whenRefund.title')}</h2>
            <p>{t('refund.whenRefund.intro')}</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('refund.whenRefund.doubleCharge')}</li>
            </ul>
            <p>
              {t('refund.whenRefund.contact')}{" "}
              <a href="mailto:contact@iso27001kit.com" className="text-primary underline underline-offset-2 hover:text-primary/80">
                contact@iso27001kit.com
              </a>{" "}
              {t('refund.whenRefund.within')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">{t('refund.cancelling.title')}</h2>
            <p>{t('refund.cancelling.content')}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
